import axios from "axios";

class Http {
  constructor() {
    this.instanceAxios = axios.create({
      withCredentials: true,
    });
  }

  get(url, configs = {}) {
    if (configs.headers) {
      configs.headers.Pragma = "no-cache";
    }
    return this.instanceAxios.get(url, configs);
  }

  post(url, data = {}, configs = {}) {
    return this.instanceAxios.post(url, data, configs);
  }

  put(url, data = {}, configs = {}) {
    return this.instanceAxios.put(url, data, configs);
  }

  delete(url, configs = {}) {
    return this.instanceAxios.delete(url, configs);
  }

  multiple(requests) {
    return axios.all(requests);
  }
}

export default new Http();
